"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _underscore = require("underscore");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var CustomRenderer = _interopRequireWildcard(require("UIComponents/utils/propTypes/customRenderer"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _ModuleFunctionTagTypes = _interopRequireDefault(require("../../constants/ModuleFunctionTagTypes"));

var getTagI18nKey = (0, _underscore.memoize)(function (tag) {
  return "contentUtils.cmv2Tags." + _ModuleFunctionTagTypes.default[tag];
});

var DefaultTagComponent = function DefaultTagComponent(_ref) {
  var tagTitle = _ref.tagTitle;
  return tagTitle;
};

var ModuleFunctionTagsList =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(ModuleFunctionTagsList, _PureComponent);

  function ModuleFunctionTagsList() {
    (0, _classCallCheck2.default)(this, ModuleFunctionTagsList);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ModuleFunctionTagsList).apply(this, arguments));
  }

  (0, _createClass2.default)(ModuleFunctionTagsList, [{
    key: "renderTag",
    value: function renderTag(tag, TagComponent) {
      return CustomRenderer.render(TagComponent, {
        key: tag,
        tag: tag,
        tagTitle: _react.default.createElement(_FormattedMessage.default, {
          message: getTagI18nKey(tag)
        })
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          ListComponent = _this$props.listComponent,
          moduleFunctions = _this$props.moduleFunctions,
          TagComponent = _this$props.tagComponent,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["listComponent", "moduleFunctions", "tagComponent"]);
      var renderedTags = moduleFunctions.map(function (tag) {
        return _this.renderTag(tag, TagComponent);
      });
      return _react.default.createElement(ListComponent, rest, renderedTags);
    }
  }]);
  return ModuleFunctionTagsList;
}(_react.PureComponent);

ModuleFunctionTagsList.propTypes = {
  listComponent: CustomRenderer.propType.isRequired,
  moduleFunctions: _propTypes.default.arrayOf(_propTypes.default.oneOf(Object.keys(_ModuleFunctionTagTypes.default))).isRequired,
  tagComponent: CustomRenderer.propType.isRequired
};
ModuleFunctionTagsList.defaultProps = {
  listComponent: _UIList.default,
  tagComponent: DefaultTagComponent
};
var _default = ModuleFunctionTagsList;
exports.default = _default;
module.exports = exports.default;